// PhotoSwipe 5+ lightweight init for product page
class ProductPhotoSwipeInit {
  constructor() {
    this.pswp = null;
    this.bound = false;
    this.handleClick = this.handleClick.bind(this);
    this.observe();
  }

  async importLib() {
    if (!this.PhotoSwipe) {
      const [{ default: PhotoSwipe }, { default: PhotoSwipeLightbox } = {}] = await Promise.all([
        import('https://unpkg.com/photoswipe@5/dist/photoswipe.esm.js'),
        import('https://unpkg.com/photoswipe@5/dist/photoswipe-lightbox.esm.js').catch(() => ({ default: null })),
      ]);
      this.PhotoSwipe = PhotoSwipe;
      this.PhotoSwipeLightbox = PhotoSwipeLightbox;
    }
  }

  async initFor(galleryEl) {
    await this.importLib();

    if (this.lightbox) {
      this.lightbox.destroy();
      this.lightbox = null;
    }

    // Use delegated lightbox to support variants re-rendering
    this.lightbox = new this.PhotoSwipeLightbox({
      gallery: '[data-pswp-gallery]'
        ,
      children: 'a.pswp-link',
      pswpModule: () => this.PhotoSwipe,
      showHideAnimationType: 'fade',
      zoom: true,
    });
    this.lightbox.init();
  }

  handleClick(e) {
    const link = e.target.closest('a.pswp-link');
    if (!link) return;
    const galleryEl = link.closest('[data-pswp-gallery]');
    if (!galleryEl) return;
    // Let PhotoSwipeLightbox handle it
  }

  observe() {
    const initOnLoad = () => {
      const gallery = document.querySelector('[data-pswp-gallery]');
      if (gallery) this.initFor(gallery);
    };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initOnLoad, { once: true });
    } else {
      initOnLoad();
    }

    // Re-init when product media gallery is replaced on variant change
    document.addEventListener('variant:update', () => {
      const gallery = document.querySelector('[data-pswp-gallery]');
      if (gallery) this.initFor(gallery);
    });
  }
}

if (!window.__productPswpInit) {
  window.__productPswpInit = new ProductPhotoSwipeInit();
}


